/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface imageLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
}
export default interface Seals {
  image: Asset;
  alt ? : string;
  imageTitle ? : string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  imageLink ? : Array < imageLinkStruct > ;
  sealKey: string;
  metadata ? : any;
}

export const Props = {
  image: Object as() => Asset,
  alt: String,
  imageTitle: String,
  aspectRatio: String,
  mobileAspectRatio: Array as() => Array < mobileAspectRatioStruct > ,
  imageLink: Array as() => Array < imageLinkStruct > ,
  sealKey: String,
  metadata: Object,
}

export const WrapperProps = {
  image: Object as() => Asset,
  alt: String,
  imageTitle: String,
  aspectRatio: String,
  mobileAspectRatio: Object,
  imageLink: Object,
  sealKey: String,
  metadata: Object,
}

export class SealsBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class SealsInstance implements Seals {
      image: Asset;
      alt ? : string;
      imageTitle ? : string;
      aspectRatio ? : string;
      mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
      imageLink ? : Array < imageLinkStruct > ;
      sealKey: string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (typeof this.image === 'object') {
          this.image = {
            ...this.image,
            link: this.image['@link'],
            name: this.image['@name'],
            path: this.image['@path'],
          };
        } else {
          this.image = null as any;
        }
        if (this.mobileAspectRatio) {
          this.mobileAspectRatio = Object.entries(this.mobileAspectRatio)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
        } else {
          this.mobileAspectRatio = null as any;
        }
        if (this.imageLink) {
          this.imageLink = Object.entries(this.imageLink)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageLink' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.imageLink.length; i1++) {

            if (this.imageLink[i1]) {
              if (this.imageLink[i1].switchable) {
                if (typeof this.imageLink[i1].switchable.download === 'object') {
                  this.imageLink[i1].switchable.download = {
                    ...this.imageLink[i1].switchable.download,
                    link: this.imageLink[i1].switchable.download['@link'],
                    name: this.imageLink[i1].switchable.download['@name'],
                    path: this.imageLink[i1].switchable.download['@path'],
                  };
                } else {
                  this.imageLink[i1].switchable.download = null as any;
                }
              }
            }
          }
        } else {
          this.imageLink = null as any;
        }
      }
    }
    return new SealsInstance(props);
  }
}
